import { useEffect, useState } from 'react';
import { Alert, Button, Card, Container, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Icon from '../../../../components/Icon/Icon';
import { whatsappAgentAPI } from '../../../../helpers/whatsappApiHandler';

const AgentInvitationResponse = ({ action }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const accessToken = useSelector(state => state.auth.access_token?.token);

  const isAccept = action === 'accept';

  useEffect(() => {
    if (token) {
      handleInvitationResponse();
    }
  }, [token]);

  const handleInvitationResponse = async () => {
    setLoading(true);
    setError('');

    try {
      let response;
      if (isAccept) {
        response = await whatsappAgentAPI.acceptInvitation(token, accessToken);
      } else {
        response = await whatsappAgentAPI.rejectInvitation(token, accessToken);
      }

      if (response.success) {
        setResult({
          success: true,
          message: isAccept 
            ? 'Invitation accepted successfully! You are now a WhatsApp Agent.'
            : 'Invitation declined successfully.'
        });
      } else {
        setError(response.message || `Failed to ${isAccept ? 'accept' : 'reject'} invitation`);
      }
    } catch (err) {
      console.error('Error processing invitation:', err);
      setError(`Failed to ${isAccept ? 'accept' : 'reject'} invitation`);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard/whatsapp');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Card style={{ maxWidth: '500px', width: '100%' }}>
        <Card.Body className="text-center p-5">
          {loading ? (
            <div>
              <Spinner animation="border" variant="primary" className="mb-3" />
              <h4>Processing your response...</h4>
              <p className="text-muted">
                Please wait while we {isAccept ? 'accept' : 'decline'} your invitation.
              </p>
            </div>
          ) : result?.success ? (
            <div>
              <div className="mb-4">
                <div style={{
                  width: '80px',
                  height: '80px',
                  backgroundColor: isAccept ? '#D1FAE5' : '#FEE2E2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px'
                }}>
                  <Icon
                    name={isAccept ? "check" : "cancel"}
                    color={isAccept ? "#10B981" : "#EF4444"}
                    width={40}
                    height={40}
                  />
                </div>
              </div>
              
              <h3 className="mb-3">
                {isAccept ? 'Welcome to the Team!' : 'Invitation Declined'}
              </h3>
              
              <p className="text-muted mb-4">
                {result.message}
              </p>

              <div className="d-flex gap-3 justify-content-center">
                {isAccept ? (
                  <>
                    <Button 
                      variant="primary" 
                      onClick={handleGoToDashboard}
                      style={{
                        backgroundColor: '#0BA9E0',
                        borderColor: '#0BA9E0',
                        padding: '10px 20px'
                      }}
                    >
                      Go to Dashboard
                    </Button>
                    <Button 
                      variant="outline-secondary" 
                      onClick={handleGoHome}
                      style={{ padding: '10px 20px' }}
                    >
                      Go Home
                    </Button>
                  </>
                ) : (
                  <Button 
                    variant="outline-secondary" 
                    onClick={handleGoHome}
                    style={{ padding: '10px 20px' }}
                  >
                    Go Home
                  </Button>
                )}
              </div>
            </div>
          ) : error ? (
            <div>
              <div className="mb-4">
                <div style={{
                  width: '80px',
                  height: '80px',
                  backgroundColor: '#FEE2E2',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px'
                }}>
                  <Icon
                    name="alert"
                    color="#EF4444"
                    width={40}
                    height={40}
                  />
                </div>
              </div>
              
              <h3 className="mb-3">Something went wrong</h3>
              
              <Alert variant="danger" className="mb-4">
                {error}
              </Alert>

              <div className="d-flex gap-3 justify-content-center">
                <Button 
                  variant="primary" 
                  onClick={handleInvitationResponse}
                  style={{
                    backgroundColor: '#0BA9E0',
                    borderColor: '#0BA9E0',
                    padding: '10px 20px'
                  }}
                >
                  Try Again
                </Button>
                <Button 
                  variant="outline-secondary" 
                  onClick={handleGoHome}
                  style={{ padding: '10px 20px' }}
                >
                  Go Home
                </Button>
              </div>
            </div>
          ) : null}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AgentInvitationResponse;